import { Roles } from 'src/enums/roles.enum';
import * as yup from 'yup';

export const FIELD_PIN = 'pin';
export const FIELD_PASSPORT_SERIES = 'passportSeries';
export const FIELD_PASSPORT_NUMBER = 'passportNumber';
export const FIELD_FIRST_NAME = 'firstName';
export const FIELD_LAST_NAME = 'lastName';
export const FIELD_MIDDLE_NAME = 'middleName';
export const FIELD_PHONE = 'phone';
export const FIELD_EMAIL = 'email';
export const FIELD_ORGANIZATION = 'organization';
export const FIELD_ROLE = 'role';
export const FIELD_LOCATION = 'location';

export const UsersEditValidationForm = yup.object().shape({
  [FIELD_PIN]: yup.string().length(14, 'error.pinflLen').required('error.required').trim(),
  //TODO organization is required if role !== APPLICANT || SUPER_ADMIN
  //[FIELD_ORGANIZATION]: yup.string().required('error.required').trim(),
  [FIELD_ROLE]: yup.string().required('error.required').trim(),
  [FIELD_LOCATION]: yup
    .string()
    .transform((value) => !value && '')
    .when([FIELD_ROLE], {
      is: Roles.ORGANIZATION_ADMIN,
      then: yup.string().required('error.required').trim(),
      otherwise: yup.string(),
    }),
});
